<mat-card class="__card">
  <div class="__content">
    <div class="__content-grid">

      <div class="__content-grid_item  is-main">
        <div class="__desc" [innerHTML]="structure | safeHtml"></div>
      </div>

      <div class="__content-grid_item  is-secondary">
        <div class="__controls">

          <div class="__recipes-checkboxes">

            <div
              class="__recipe-checkbox-wrap"
              [class.is-active]="devEnv">

              <mat-checkbox
                [(ngModel)]="devEnv"
                [labelPosition]="'after'"
                class="__recipes-checkbox">
                <div class="__recipes-checkbox_title"><code>dev</code> env</div>
                <div class="__recipes-checkbox_resources">
                  <div *ngFor="let item of resourcesNonha?.split(',')">
                    {{ item }}
                  </div>
                </div>
              </mat-checkbox>

              <div class="__show-config-button-wrap">
                <button
                  class="__show-config-button  c-button--smaller"
                  mat-button
                  (click)="showProjectYamlClicked.emit({ id, mode: 'non-ha' })">
                  Show yaml config
                </button>
              </div>

            </div>

            <div
              class="__recipe-checkbox-wrap"
              [class.is-active]="prodEnv">

              <mat-checkbox
                [(ngModel)]="prodEnv"
                [labelPosition]="'after'"
                class="__recipes-checkbox">
                <div class="__recipes-checkbox_title"><code>prod</code> env</div>
                <div class="__recipes-checkbox_resources">
                  <div *ngFor="let item of resourcesHa?.split(',')">
                    {{ item }}
                  </div>
                </div>
              </mat-checkbox>

              <div class="__show-config-button-wrap">
                <button
                  class="__show-config-button  c-button--smaller"
                  mat-button
                  (click)="showProjectYamlClicked.emit({ id, mode: 'ha' })">
                  Show yaml config
                </button>
              </div>

            </div>

          </div>

          <div class="__controls-button-wrap" #createButtonWrapRef>
            <zef-progress-error
              [loading]="projectImportLoading"
              full>
              <button
                (click)="importProjectClicked.emit({
                  ref: createButtonWrapRef,
                  devEnv: devEnv,
                  prodEnv: prodEnv
                })"
                color="accent"
                [disabled]="!devEnv && !prodEnv"
                class="__controls_button  c-button  c-button--full  c-button--larger"
                mat-flat-button>
                <ng-container *ngIf="!devEnv && !prodEnv">Select environment...</ng-container>
                <ng-container *ngIf="!devEnv && prodEnv">Create <strong>prod</strong> environment</ng-container>
                <ng-container *ngIf="devEnv && !prodEnv">Create <strong>dev</strong> environment</ng-container>
                <ng-container *ngIf="devEnv && prodEnv">Create <strong>dev</strong> and <strong>prod</strong> environment</ng-container>
              </button>
            </zef-progress-error>
          </div>

        </div>
      </div>

    </div>
  </div>
</mat-card>
